import axios, { AxiosRequestConfig, Method } from 'axios'
import _ from 'lodash'
import env from '../env'
import { token } from './auth-service'

function createRequestConfig(method: Method, endpoint: string, settings: AxiosRequestConfig = {}) {
  const defaultSettings: AxiosRequestConfig = {
    method,
    url: `${env.appBaseUrl}/api/${endpoint}`
  }
  if(token.value) {
    defaultSettings.headers = { Authorization: `Bearer ${token.value}` }
  }
  return _.merge({}, defaultSettings, settings)
}

async function downloadFile(endpoint: string, name = '', params = {}) {
  const requestConfig = createRequestConfig('GET', endpoint, {
    params,
    responseType: 'blob'
  })
  return axios(requestConfig).then(response => {
    const filename = response.headers['content-disposition']?.split('filename=')[1]?.split(';')[0] || name
    const url = window.URL.createObjectURL(response.data as Blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
  })
}

async function apiRequest<T>(method: Method, endpoint: string, settings: AxiosRequestConfig = {}): Promise<T> {
  const defaultSettings: AxiosRequestConfig = {
    method,
    url: `${env.appBaseUrl}/api/${endpoint}`
  }
  if(token.value) {
    defaultSettings.headers = { Authorization: `Bearer ${token.value}` }
  }
  const requestConfig = createRequestConfig(method, endpoint, settings)
  const { data } = await axios(requestConfig)
  return data as T
}

export { apiRequest, downloadFile }
